import { z } from 'zod'

export const UserFieldSchema = z.object({
  field_id: z.number(),
  type: z.string(),
  segment_type: z.string(),
  caption: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  folder_id: z.number(),
  ts_created: z.string().optional(),
})
